// Hours are a single reporting period. Missing inputs are not zero.
export function finiteHours(value) {
  if ((typeof value === 'string' && value.trim() === '') || value === null || value === undefined || typeof value === 'boolean') return null;
  const n = Number(value);
  return Number.isFinite(n) && n >= 0 && n <= 1000000 ? n : null;
}
const nearZero = value => Math.abs(value) < 1e-9 ? 0 : value;
export function utilization(input) {
  const values = ['scheduled', 'leave', 'billable', 'target'].map(k => finiteHours(input[k]));
  if (values.includes(null)) return { error: 'numbers' };
  const [scheduled, leave, billable, target] = values;
  const available = scheduled - leave;
  if (available <= 0 || target > 100) return { error: 'range' };
  if (billable - available > 1e-9) return { error: 'overtime' };
  const targetHours = available * target / 100;
  return { available, rate: Math.min(100, billable / available * 100), targetHours, gap: nearZero(targetHours - billable), nonBillable: Math.max(0, available - billable) };
}
export function capacity(rows) {
  if (!rows.length) return { error: 'rows' };
  const results = [];
  for (const row of rows) {
    const values = ['scheduled', 'leave', 'internal', 'committed', 'proposed'].map(k => finiteHours(row[k]));
    if (values.includes(null)) return { error: 'numbers' };
    const [scheduled, leave, internal, committed, proposed] = values;
    if (leave + internal - scheduled > 1e-9) return { error: 'range' };
    const clientCapacity = Math.max(0, scheduled - leave - internal);
    results.push({ ...row, clientCapacity, remaining: nearZero(clientCapacity - committed - proposed) });
  }
  const sum = key => results.reduce((total, row) => total + row[key], 0);
  return { rows: results, clientCapacity: sum('clientCapacity'), remaining: sum('remaining'), shortage: results.reduce((n, r) => n + Math.max(0, -r.remaining), 0), spare: results.reduce((n, r) => n + Math.max(0, r.remaining), 0) };
}
export function csvCell(value) {
  let s = String(value);
  if (/^[=+@\-\t\r]/.test(s) && typeof value !== 'number') s = "'" + s;
  return '"' + s.replaceAll('"', '""') + '"';
}
export function toCsv(rows) { return '\ufeff' + rows.map(row => row.map(csvCell).join(',')).join('\r\n'); }
